import { authFetch } from "@/plugins/axiosConfig";
import router from "@/routes";
import axios from "axios";

const userStore = {
  namespaced: true,
  state: {
    accessToken: "",
    status: {
      isInit: true,
      complete: false,
      existApiKey: false,
      existSecretKey: false,
      dualSidePosition: false,
      canTrade: false,
    },
  },
  getters: {
    IS_LOGIN: () =>
      localStorage.getItem("user") && localStorage.getItem("user") != "null",
    ACCESS_TOKEN: (state) => state.accessToken,
    IS_INIT_COMPLETE: (state) => state.status.complete,
    USER_STATUS: (state) => state.status,
  },
  mutations: {
    // 유저 accessToken 저장
    MU_SAVE_TOKEN: (state, payload) => {
      const { accessToken, refreshToken } = payload;

      state.accessToken = accessToken;
      localStorage.setItem("user", accessToken);
      if (refreshToken) {
        localStorage.setItem("userRefresh", refreshToken);
      }
    },

    MU_UPDATE_MEMBER_KEY: () => {
      console.log("done");
    },

    MU_SAVE_STATUS_WITH_LS: (state, payload) => {
      localStorage.setItem("userStatus", JSON.stringify(payload));
      state.status = { ...state.status, ...payload };
    },
    MU_SAVE_STATUS: (state, payload) => {
      state.status = { ...state.status, ...payload };
    },
    // MU_SAVE_SYMBOL_CONFIG:(state,payload) => {

    // }

    MU_UPDATE_DUAL_POSITION: (state) => {
      state.status.dualSidePosition = true;
    },

    MU_SAVE_KEY: (state) => {
      state.status.existApiKey = true;
      state.status.existSecretKey = true;
    },
    MU_RESET_AUTH: (state) => {
      // eslint-disable-next-line
      state = {
        accessToken: "",
        status: {
          isInit: true,
          complete: false,
          existApiKey: false,
          existSecretKey: false,
          dualSidePosition: false,
          canTrade: false,
        },
      };
      localStorage.removeItem("userStatus");
    },
  },
  actions: {
    /* accessToken 저장 */
    AC_ACCESS_TOKEN: ({ commit }, payload) => {
      // mutation 호출
      commit("MU_SAVE_TOKEN", payload);
    },

    /* accessToken 만료시, 갱신 */
    AC_REFRESH_TOKEN: async ({ commit }) => {
      // api 로직 구현 예정
      let response = null;
      try {
        response = await axios.post(
          // `https://ats.api.erumcompany.com/api/auth/refresh`,
          `${process.env.VUE_APP_BASE_URL}/api/auth/refresh`,
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("userRefresh")}`,
            },
          }
        );
        const token = {
          accessToken: response.data,
        };
        commit("MU_SAVE_TOKEN", token);
      } catch (e) {
        if (e.status === 401) {
          alert("로그인이 만료되었습니다. 로그인 페이지로 이동합니다.");
          router.push("/auth/login");
        }
        console.log(e);
      }
      // mutation 호출
    },

    /**
     * 유저의 accessToken이 유효한지 확인
     *
     */
    AC_CHECK_ACCESS_TOKEN: async ({ commit }) => {
      try {
        await axios.get(
          // "https://ats.api.erumcompany.com/api/auth/check",
          `${process.env.VUE_APP_BASE_URL}/api/auth/check`,
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("user")}`,
            },
          }
        );
        const token = {
          accessToken: localStorage.getItem("user"),
        };
        commit("MU_SAVE_TOKEN", token);
      } catch (e) {
        alert("로그인이 만료되었습니다. 다시 로그인을 해주시기 바랍니다.");
        router.push("/auth/login");
      }
    },

    AC_LOGIN: async ({ commit }, payload) => {
      const response = await axios.post(
        // `https://ats.api.erumcompany.com/api/auth/login`,
        `${process.env.VUE_APP_BASE_URL}/api/auth/login`,
        payload
      );
      console.log(response.data);
      const jwt = response.data;

      await commit("MU_SAVE_TOKEN", jwt);
    },

    /**
     * 유저 초기 설정 완료 여부 확인
     */
    AC_USER_INIT_CHECK: async ({ state, commit }) => {
      // 새로고침 되거나, 최초 진입의 경우.
      if (state.status.isInit) {
        const localStatus = localStorage.getItem("userStatus");
        if (localStatus && localStatus != "null") {
          // 로컬스토리지에 저장되어 있는 경우
          const localStorageUserStatue = JSON.parse(localStatus);
          commit("MU_SAVE_STATUS", localStorageUserStatue);
        } else {
          // 로컬 스토리지에 저장되어 있지 않은 경우
          try {
            const response = await authFetch.get("/api/member/valid/init");
            const apiResult = response.data;

            commit("MU_SAVE_STATUS_WITH_LS", apiResult);
          } catch (e) {
            if (e.status == undefined) {
              alert("잠시 후 다시 시도해주시기 바랍니다.");
            } else {
              console.log("// error", e);
            }
          }
        }
      }
    },

    AC_INIT_CHECK: async ({ commit }) => {
      try {
        const response = await authFetch.get("/api/member/valid/init");
        const apiResult = response.data;

        commit("MU_SAVE_STATUS_WITH_LS", apiResult);

        alert("메인 페이지로 이동합니다.");
        router.push("/");
      } catch (e) {
        if (e.status == undefined) {
          alert("잠시 후 다시 시도해주시기 바랍니다.");
        } else {
          console.log("// error", e);
        }
      }
    },

    AC_API_SECRET_KEY_SAVE: async ({ commit }, payload) => {
      const response = await authFetch.post("/api/member/key", payload);
      if (response.status === 200 || response.status === 201) {
        if (response.data) {
          commit("MU_SAVE_KEY");
        } else {
          alert("등록도중 오류가 발생했습니다.");
        }
      } else {
        alert("등록도중 오류가 발생했습니다.");
      }
    },
    AC_CHECK_API_SECRET_KEY: async ({ commit }) => {
      const response = await authFetch.get("/api/member/key");

      let resultFlag = false;
      if (response.status === 200) {
        if (response.data) {
          resultFlag = true;
          commit("MU_SAVE_KEY");
        }
      }
      return resultFlag;
    },
    AC_UPDATE_MEMBER_KEY: async ({ commit }, payload) => {
      const response = await authFetch.patch("/api/member/key", payload);

      if (response.status === 200 || response.status === 201) {
        alert("성공적으로 처리되었습니다. 로그인 페이지로 이동합니다.");
        router.push("/auth/login");
      } else {
        alert(
          "변경중 오류가 발생했습니다. 잠시 후 다시 시도해주시기 바랍니다."
        );
      }
      commit("MU_UPDATE_MEMBER_KEY");
    },
    AC_POST_CONFIG_ACCOUNT: async ({ commit }) => {
      const response = await authFetch.get("/api/member/config/account");
      if (response.status === 200 || response.status === 201) {
        const reponseData = response.data;
        commit("MU_SAVE_STATUS", reponseData);
      } else {
        alert(
          "바이낸스 기본 정보를 불러오는 도중 오류가 발생했습니다. 새로고침 후 다시 진행해주시기 바랍니다."
        );
      }
    },
  },
};

export default userStore;
